<template>
  <v-row>
    <!-- <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-text-field
        v-model="editedItem.short_description"
        :error-messages="error.short_description"
        label="Descrizione sintetica"
      ></v-text-field>
    </v-col> -->
    <v-col cols="12" sm="4">
      <v-select
        v-model="editedItem.kind"
        :error-messages="error.kind"
        :items="[
          { value: 1, text: 'auto' },
          { value: 2, text: 'treno' },
          { value: 3, text: 'aereo' },
          { value: 3, text: 'altro' },
        ]"
        :readonly="!profile.is_staff"
        label="Tipo trasferimento"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.start_date"
        :error-messages="error.start_date"
        label="Data partenza"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.start_place"
        :error-messages="error.start_place"
        label="Luogo partenza"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <date-time-picker
        v-model="editedItem.end_date"
        :error-messages="error.end_date"
        label="Data arrivo"
        :disabled="!profile.is_staff"
      ></date-time-picker>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.end_place"
        :error-messages="error.end_place"
        label="Luogo arrivo"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.people"
        :error-messages="error.people"
        :model="showPersonModel"
        :extra-params="modelFk"
        item-text="person__name"
        item-value="id"
        label="Musicisti"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
      <ul>
        <li v-for="person in editedItem.transport__people_info" :key="person.telephone_number">
          {{ person.first_name }} {{ person.last_name }} - {{ person.telephone_number }}
        </li>
      </ul>
    </v-col>
    <v-col cols="12" sm="4">
      <autocomplete
        v-model="editedItem.drivers"
        :error-messages="error.drivers"
        :model="showPersonModel"
        :extra-params="modelFk"
        item-text="person__name"
        item-value="id"
        label="Autisti"
        multiple
        :readonly="!profile.is_staff"
      ></autocomplete>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        v-model="editedItem.guests"
        :error-messages="error.guests"
        label="Ospiti"
        :readonly="!profile.is_staff"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-select
        v-model="editedItem.status"
        :error-messages="error.status"
        :items="[
          { value: 1, text: 'ipotizzato' },
          { value: 2, text: 'confermato' },
          { value: 3, text: 'pagato' },
        ]"
        label="Stato"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-text-field
        v-model="editedItem.cost"
        :error-messages="error.cost"
        label="Costo"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-text-field
        v-model="editedItem.tickets_download_url"
        :error-messages="error.tickets_download_url"
        label="Link download biglietti"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="4" v-if="profile.is_staff">
      <v-checkbox
        v-model="editedItem.is_ocm_pickup"
        :error-messages="error.is_ocm_pickup"
        label="Pick-up OCM"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" sm="4">
      <v-checkbox
        v-model="editedItem.is_cumbersome"
        :error-messages="error.is_cumbersome"
        label="Strumento ingombrante"
        :readonly="!profile.is_staff"
      ></v-checkbox>
    </v-col>
    <v-col v-if="profile.is_staff || hasDriverRole" cols="12" sm="4">
      <v-textarea
        v-model="editedItem.notes"
        :error-messages="error.notes"
        :readonly="!profile.is_staff"
        label="Note"
      ></v-textarea>
    </v-col>
    <v-col
      v-if="
        profile.is_staff &&
        editedItem.warnings &&
        editedItem.warnings.length > 0
      "
      cols="12"
      sm="4"
    >
      <ul>
        <li
          v-for="(warning, index) in editedItem.warnings"
          :key="index"
          class="red--text"
        >
          <template v-if="warning.type == 'transport_outside_person_availability_range'">
            Il trasporto è all'infuori del range di disponibilità di
            {{ warning.person }}
          </template>
          <template v-else-if="warning.type == 'person_transports_overlap'">
            Il trasporto si sovrappone ad altri trasporti di
            {{ warning.person }}
          </template>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
  import models from "@/models"
  import { get } from 'lodash'

  export default {
    props: {
      editedItem: {
        type: Object,
        required: true,
      },
      error: {
        type: Object,
        default: () => ({}),
      },
      modelFk: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showPersonModel: models.ShowPerson,
      }
    },
    methods: {
      formatPersonInfo(person) {
        return `${person.first_name} ${person.last_name} - ${person.telephone_number}`;
      }
    },
    computed: {
      hasDriverRole() {
        const roles = get(this.profile, 'person__roles', []);
        return roles.some(role => role.id === 1);
      }
    }
  }
  </script>
